'use client'

import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { GenericCTAProps } from './GenericCTA.interface'
import styles from './GenericCTA.module.scss'

const GenericCTA: React.FC<GenericCTAProps> = ({
  ctaText,
  ctaURL,
  variant = 'red',
  onClick,
  className,
  iconSrc,
  iconAlt = 'Button icon',
  iconWidth = 14,
  iconHeight = 14,
}) => {
  const buttonClasses = `${styles.ctaButton} ${styles[variant]} ${className || ''}`

  // Check if ctaURL is an external URL
  const isExternal = ctaURL && /^(http|https):\/\//i.test(ctaURL)

  const buttonContent = (
    <>
      {iconSrc && (
        <Image
          src={iconSrc}
          alt={iconAlt}
          width={iconWidth}
          height={iconHeight}
          className={styles.buttonIcon}
        />
      )}
      <span>{ctaText}</span>
    </>
  )

  const isNavigational = ctaURL && ctaURL !== '#' && !onClick

  if (isNavigational) {
    const linkProps = isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {}

    return (
      <Link href={ctaURL} className={buttonClasses} {...linkProps}>
        {buttonContent}
      </Link>
    )
  }

  // non_navigational buttons, explicitly set type="button" to prevent accidental form submission
  return (
    <button className={buttonClasses} onClick={onClick} type="button">
      {buttonContent}
    </button>
  )
}

export default GenericCTA
